import { useQuery } from '@tanstack/react-query';

import { fetchInsuredEmployeesByMonthApi } from '../api';

export default function useInsuredEmployeesChartQuery() {
  return useQuery(
    ['statistics', 'insured-employees-by-month'],
    () => fetchInsuredEmployeesByMonthApi(),
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
    }
  );
}
